import React, { useState } from 'react';
import { CloudUpload as Icon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import ChargersTask from '../../../resources/ChargersTask';

import { ActionWrap } from './style';
import { makeErrorHandler } from '../../../resources/helper';

function UploadTaskAction(props) {
  const { task, alert } = props;
  const [state, setState] = useState({ loading: false });
  const { loading } = state;

  const click = () => {
    if (!loading) {
      setState({ loading: true });
      ChargersTask
        .upload({ chargerId: task.chargerUuid, taskId: task.uuid })
        .then(() => {
          alert('Uploading has been started successfully');
        })
        .catch(makeErrorHandler(alert, { 400: 'The file can not be uploaded' }))
        .finally(() => setState({ loading: false }));
    }
  };

  return (
    <ActionWrap
      onClick={click}
      className={`link ${loading ? 'busy' : ''}`}
    >
      <CircularProgress size={10} />
      <Icon />
      {' '}
      Upload (
      {task.artifactSize}
      {' '}
      Mb)
    </ActionWrap>
  );
}

export default UploadTaskAction;
